import { axios } from 'lib/axios';

export function createPost(data: any) {
  return axios.post('/profile/post', data);
}
